import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { AlarmTypesFailure, AlarmTypesRequest, AlarmTypesSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'alarmTypes';

export interface State {
  data: ParameterResult[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(AlarmTypesFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(AlarmTypesRequest, state => ({ ...state, error: null, loading: true })),
    on(AlarmTypesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
